import {AbstractControl, ValidatorFn} from '@angular/forms';
import * as moment from 'moment';

export function minDateValidator(min): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const format = 'DD-MM-YYYY';
    const date = moment(control.value, format, true);
    const minDate = moment(min, format, true);
    if (!date.isValid()) {
      return null;
    }
    return (date.isAfter(minDate)) ? null : {minDate: true};
  };
}
